import { CgHome, CgProfile, CgQr } from "react-icons/cg";
import { TbCalendarSearch } from "react-icons/tb";
import { Award } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

export default function MobileNBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const isBusiness = localStorage.getItem("isBusiness") === "true";

  const navItems = [
    { path: isBusiness ? "/loggedinartistbussiness" : "/loggedinartist", label: "Home", icon: CgHome },
    { path: isBusiness ? "/businessQr" : "/me", label: "QR Code", icon: CgQr },
    { path: isBusiness ? "/businessCalendar" : "/bookevent", label: "Calendar", icon: TbCalendarSearch },
    { path: "/rewards", label: "Rewards", icon: Award },
    { path: isBusiness ? "/businessProfile" : "/artistprofile", label: "Profile", icon: CgProfile },
  ];

  return (
    <nav className="md:hidden w-full max-w-md mx-auto grid grid-cols-5 fixed z-20 bottom-0 left-0 right-0 bg-white px-1 py-1 shadow-lg rounded-t-xl border-t border-gray-100">
      {navItems.map(({ path, label, icon: Icon }) => {
        const isActive = currentPath === path;
        return (
          <button
            key={path}
            onClick={() => navigate(path)}
            className={`flex flex-col items-center cursor-pointer focus:outline-none transition-colors ${isActive ? "text-logo" : "text-gray-500 hover:text-gray-700"
              }`}
          >
            <div className={`p-2 rounded-full ${isActive ? "bg-logo/20" : ""}`}>
              <Icon className="text-xl" />
            </div>
            <span className="text-xs font-medium mt-1">{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
